<template>
  <div class="transport-tab-list">
    <div v-for="item in list"
         :key="item.title"
         @click="changeTransport(item)"
         class="transport-tab-list-item"
         :class="{ 'transport-tab-list-item_active': item.code === activeCode }">
      <img :src="item.code === activeCode ? item.activeIcon : item.icon" alt="">
      <span>{{ item.title }}</span>
    </div>
    <!--<div class="transport-tab-list-item" @click="toInquiry">
      <img :src="ossPath + '/pages/home/ico-fullInquiry.png'" alt="">
      <span>整柜询盘</span>
    </div>-->
  </div>
</template>

<script>
import {sendCustomerOperationRecord} from "@/assets/js/utils"
export default {
  name: "homeTransportTabs",
  data() {
    return {
      list: [
        {
          title: 'FBA',
          code: '1',
          icon: this.ossPath + '/pages/home/icon_FBA1.png',
          activeIcon: this.ossPath + '/pages/home/icon_FBA_active.png'
        },
        {
          title: '海运专线',
          code: '2',
          icon: this.ossPath + '/pages/home/icon_sea.png',
          activeIcon: this.ossPath + '/pages/home/icon_sea_active.png'
        },
        {
          title: '空运专线',
          code: '3',
          icon: this.ossPath + '/pages/home/icon_air.png',
          activeIcon: this.ossPath + '/pages/home/icon_air_active.png'
        },
        {
          title: '陆运专线',
          code: '4',
          icon: this.ossPath + '/pages/home/icon_land.png',
          activeIcon: this.ossPath + '/pages/home/icon_land_active.png'
        }
      ],
      activeCode: '1'
    }
  },
  methods: {
    changeTransport(item) {
      this.activeCode = item.code
      this.$emit('change', item.code)
    },
    toInquiry() {
      sendCustomerOperationRecord("整柜询盘")
      this.$router.push({ path: "/placeOrder/placeindexInfo/inquiryHall" })
    }
  }
}
</script>

<style lang="scss" scoped>
.transport-tab-list {
  width: 100%;
  height: 50px;
  // background: linear-gradient(180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.9) 100%);
  background: #FFFFFF;
  // border-radius: 16px 16px 0 0;
  border-radius: 0 16px 0 0;
  border-top: 1px solid #FFFFFF;
  //border-left: 1px solid #FFFFFF;
  border-right: 1px solid #FFFFFF;
  z-index: 99;
  position: relative;
  display: flex;
  box-sizing: border-box;

  &-item {
    width: 200px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #141414;
    line-height: 22px;
    cursor: pointer;
    transition: all .3s ease;
    position: relative;
    img {
      margin-right: 3px;
    }
    &_active {
      // height: 80px;
      // margin-top: -30px;
      // background: #FFFFFF;
      border-radius: 16px 16px 0 0;
      font-size: 18px;
      font-weight: 600;
      color: #FF4D01;
      line-height: 25px;
      &::after {
        content: "";
        width: 100px;
        height: 4px;
        background: #FF4D01;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeProductTabs.vue